/* eslint-disable react/require-default-props */
import React from 'react'
import PropTypes from 'prop-types'
import t from 'format-message'

import {Billboard} from '@instructure/ui-billboard'
import {Button} from '@instructure/ui-buttons'
import {Img} from '@instructure/ui-img'
import {View} from '@instructure/ui-view'
import img403 from './images/403.svg'

const ERROR_CONFIG = {
  400: {
    heading: t('400 - Bad Request'),
    message: t(
      'Cannot launch without required parameters. Please contact support to get this issue resolved.',
    ),
    image: img403,
  },
  403: {
    heading: t('403 - Forbidden'),
    image: img403,
    getMessage: rldbEnabled =>
      rldbEnabled
        ? t('This content can only be viewed in the Respondus browser.')
        : t('You do not have permission to view this page. Please contact your Administrator.'),
  },
}

const GENERIC_ERROR = {
  heading: null,
  image: img403,
  message: t(
    'An unexpected error occurred while loading this page. Please try returning to the home page.',
  ),
}

export function Errors({status, rldbEnabled, showHomeButton = false, baseUrl = '/'}) {
  const handleGoHome = () => {
    // eslint-disable-next-line immutable/no-mutation
    window.location.href = localStorage?.getItem('return_to') || baseUrl
  }

  const parsed = status ? parseInt(status, 10) : null
  const config = (parsed && ERROR_CONFIG[parsed]) || GENERIC_ERROR

  const heading = config?.heading || GENERIC_ERROR.heading
  const image = config?.image || GENERIC_ERROR.image
  const message = config?.getMessage?.(rldbEnabled) || config?.message || GENERIC_ERROR.message

  return (
    <div>
      <Billboard
        heading={heading}
        hero={<Img src={image} width={700} height={400} />}
        message={message}
      />

      {showHomeButton && (
        <View as="div" textAlign="center" margin="small 0 0 0">
          <Button
            as="a"
            href={localStorage?.getItem('return_to') || baseUrl}
            color="primary"
            size="large"
            target="_top"
          >
            {t('Return')}
          </Button>
        </View>
      )}
    </div>
  )
}
// eslint-disable-next-line immutable/no-mutation
Errors.propTypes = {
  status: PropTypes.string,
  rldbEnabled: PropTypes.bool,
  showHomeButton: PropTypes.bool,
  baseUrl: PropTypes.string,
}
